<template>
  <v-row>
    <v-col
      cols="12"
      sm="6"
      md="3"
    >
      <v-card
        elevation="4"
        rounded="lg"
        class="stat-card"
      >
        <v-card-text>
          <div class="stat-label">
            Total Calls
          </div>
          <div class="stat-value color_green--text">
            <template v-if="loading">
              <v-skeleton-loader
                type="text"
                width="120"
              />
            </template>
            <template v-else>
              {{ totalFormatted }}
            </template>
          </div>
          <div class="stat-sub">
            Year {{ year }}
          </div>
        </v-card-text>
        <v-icon
          class="stat-icon"
          color="color_green"
          size="48"
        >
          mdi-phone-outgoing
        </v-icon>
      </v-card>
    </v-col>

    <v-col
      cols="12"
      sm="6"
      md="3"
    >
      <v-card
        elevation="4"
        rounded="lg"
        class="stat-card"
      >
        <v-card-text>
          <div class="stat-label">
            Unique Users
          </div>
          <div class="stat-value primary--text">
            <template v-if="loading">
              <v-skeleton-loader
                type="text"
                width="80"
              />
            </template>
            <template v-else>
              {{ overview ? overview.unique_users.toLocaleString('it-IT') : '—' }}
            </template>
          </div>
          <div class="stat-sub">
            Active callers
          </div>
        </v-card-text>
        <v-icon
          class="stat-icon"
          color="primary"
          size="48"
        >
          mdi-account-group-outline
        </v-icon>
      </v-card>
    </v-col>

    <v-col
      cols="12"
      sm="6"
      md="3"
    >
      <v-card
        elevation="4"
        rounded="lg"
        class="stat-card"
      >
        <v-card-text>
          <div class="stat-label">
            Top Service
          </div>
          <div class="stat-value amber--text text--darken-2">
            <template v-if="loading">
              <v-skeleton-loader
                type="text"
                width="80"
              />
            </template>
            <template v-else>
              {{ overview ? (overview.most_used_service || '—') : '—' }}
            </template>
          </div>
          <div class="stat-sub">
            Most called
          </div>
        </v-card-text>
        <v-icon
          class="stat-icon"
          color="amber darken-2"
          size="48"
        >
          mdi-api
        </v-icon>
      </v-card>
    </v-col>

    <v-col
      cols="12"
      sm="6"
      md="3"
    >
      <v-card
        elevation="4"
        rounded="lg"
        class="stat-card"
      >
        <v-card-text>
          <div class="stat-label">
            Calls Today
          </div>
          <div class="stat-value teal--text">
            <template v-if="loading">
              <v-skeleton-loader
                type="text"
                width="80"
              />
            </template>
            <template v-else>
              {{ overview ? overview.calls_today.toLocaleString('it-IT') : '—' }}
            </template>
          </div>
          <div class="stat-sub">
            {{ today }}
          </div>
        </v-card-text>
        <v-icon
          class="stat-icon"
          color="teal"
          size="48"
        >
          mdi-calendar-today
        </v-icon>
      </v-card>
    </v-col>

    <v-col
      cols="12"
      sm="6"
      md="3"
    >
      <v-card
        elevation="4"
        rounded="lg"
        class="stat-card"
      >
        <v-card-text>
          <div class="stat-label">
            Calls with Geo
          </div>
          <div class="stat-value deep-purple--text">
            <template v-if="loading">
              <v-skeleton-loader
                type="text"
                width="80"
              />
            </template>
            <template v-else>
              {{ overview ? overview.calls_with_geo.toLocaleString('it-IT') : '—' }}
            </template>
          </div>
          <div class="stat-sub">
            lat / lon present
          </div>
        </v-card-text>
        <v-icon
          class="stat-icon"
          color="deep-purple"
          size="48"
        >
          mdi-map-marker-radius
        </v-icon>
      </v-card>
    </v-col>

    <v-col
      cols="12"
      sm="6"
      md="3"
    >
      <v-card
        elevation="4"
        rounded="lg"
        class="stat-card"
      >
        <v-card-text>
          <div class="stat-label">
            Unique Stations
          </div>
          <div class="stat-value indigo--text">
            <template v-if="loading">
              <v-skeleton-loader
                type="text"
                width="80"
              />
            </template>
            <template v-else>
              {{ overview ? overview.unique_stations.toLocaleString('it-IT') : '—' }}
            </template>
          </div>
          <div class="stat-sub">
            Distinct station_name
          </div>
        </v-card-text>
        <v-icon
          class="stat-icon"
          color="indigo"
          size="48"
        >
          mdi-weather-station
        </v-icon>
      </v-card>
    </v-col>

    <v-col
      cols="12"
      sm="6"
      md="3"
    >
      <v-card
        elevation="4"
        rounded="lg"
        class="stat-card"
      >
        <v-card-text>
          <div class="stat-label">
            Top Workspace
          </div>
          <div class="stat-value blue-grey--text text--darken-2 stat-value--sm">
            <template v-if="loading">
              <v-skeleton-loader
                type="text"
                width="100"
              />
            </template>
            <template v-else>
              {{ overview ? (overview.most_used_workspace || '—') : '—' }}
            </template>
          </div>
          <div class="stat-sub">
            {{ overview ? overview.unique_workspaces.toLocaleString('it-IT') : '—' }} workspaces
          </div>
        </v-card-text>
        <v-icon
          class="stat-icon"
          color="blue-grey darken-2"
          size="48"
        >
          mdi-folder-multiple-outline
        </v-icon>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'OverviewCards',
  props: {
    overview: { type: Object, default: null },
    year: { type: Number, required: true },
    loading: { type: Boolean, default: false }
  },
  computed: {
    totalFormatted() {
      return this.overview
        ? this.overview.total_calls.toLocaleString('it-IT')
        : '—';
    },
    today() {
      return new Date().toLocaleDateString('it-IT');
    }
  }
};
</script>

<style scoped>
.stat-card {
  position: relative;
  overflow: hidden;
  min-height: 100px;
}
.stat-label {
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: rgba(0, 0, 0, 0.5);
  margin-bottom: 4px;
}
.stat-value {
  font-size: 28px;
  font-weight: 700;
  line-height: 1.1;
}
.stat-value--sm {
  font-size: 18px;
  word-break: break-word;
}
.stat-sub {
  font-size: 11px;
  color: rgba(0, 0, 0, 0.38);
  margin-top: 4px;
}
.stat-icon {
  position: absolute;
  right: 12px;
  bottom: 8px;
  opacity: 0.12;
}
</style>
